<template>
<div class="model-12">
  <div class="graphic-nav" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color}">
    <div class="wrap">
      <div v-for="(v,index) in editablePageConfig.editable_page_config_content.nav" :key="index" class="item" :style="'width:'+getBannerStyle.width+'%'" @click="goAdUrl(v.link)">
        <div>
          <img :src="v.image">
        </div>
        <span>{{v.text}}</span>
    </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Model12',
  data () {
    return {
    }
  },
  props: ['editablePageConfig','editablePage'],
  computed: {
	getBannerStyle(){
		var width
		if(this.editablePageConfig.editable_page_config_content['show_format']==1){
			width=25
		}else if(this.editablePageConfig.editable_page_config_content['show_format']==2){
			width=20
		}
		return {width:width}
	}
  },
  methods: {
    goAdUrl (url) {
      this.$router.push({ path: url })
    }
  }
}
</script>

<style lang="scss" scoped>
.model-12 .graphic-nav{
	border-radius: 5px;
}
.model-12 .graphic-nav>.wrap {
   /* overflow-x: hidden;
   white-space: nowrap;
	background: #ffffff;
	*/
	display: flex;
   /* justify-content: space-around;
	*/
	flex-wrap: wrap;
	padding: 0 5px;
}
.model-12 .graphic-nav .item {
	text-align: center;
	float: none;
	display: inline-block;
	box-sizing: border-box;
	padding: 8px 5px;
}
.model-12 .graphic-nav .item img {
	width: 45px;
	height: 45px;
}
.model-12 .graphic-nav .item span {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	display: block;
	font-size: 13px;
}
</style>
